<template>
    <div>
        <legend class="border-bottom">{{ $t('widgetStart') }}:</legend>

        <div class="row justify-content-md-center">
            <div class="btn-group" role="group" aria-label="...">
                <button v-on:click="activeTabStartWidget=1"
                        v-bind:class="[ activeTabStartWidget === 1 ? 'btn active btn-primary' : 'btn btn-light' ]"
                        type="button">{{ $t('portSearch') }}
                </button>
                <button v-on:click="activeTabStartWidget=2"
                        v-bind:class="[ activeTabStartWidget === 2 ? 'btn active btn-primary' : 'btn btn-light' ]"
                        type="button">{{ $t('cruiseSearch') }}
                </button>
            </div>
        </div>

        <div v-if="activeTabStartWidget === 1" class="mt-3">
            <div class="form-group row">
                <label for="widgetPortId" class="col-lg-4 col-form-label required">{{ $t('portSelect')
                    }}</label>
                <div class="col-lg-8">
                    <v-select id="widgetPortId" name="widgetPortId" v-model="widgetPortId" :options="ports" label="port"
                              :reduce="port => port.id">
                        <template v-slot:option="option">
                            {{ option.port }}
                        </template>
                    </v-select>
                </div>
            </div>
        </div>

        <div v-if="activeTabStartWidget === 2" class="mt-3">
            <div class="form-group row">
                <label for="cruiseCompanyId" class="col-lg-4 col-form-label required">{{
                    $t('cruiseCompanySelect')
                    }}</label>
                <div class="col-lg-8">
                    <v-select id="cruiseCompanyId" name="cruiseCompanyId" v-model="cruiseCompanyId"
                              :options="cruiseCompany" label="company" :reduce="company => company.id">
                        <template v-slot:option="option">
                            {{ option.company }}
                        </template>
                    </v-select>
                </div>
                <label v-if="cruiseCompanyId" for="cruiseShipId"
                       class="col-lg-4 col-form-label required">{{
                    $t('cruiseShipSelect')
                    }}</label>
                <div class="col-lg-8">
                    <v-select v-if="cruiseCompanyId" id="cruiseShipId" name="cruiseShipId"
                              v-model="cruiseShipId" :options="cruiseShip" label="ship"
                              :reduce="ship => ship.id">
                        <template v-slot:option="option">
                            {{ option.ship }}
                        </template>
                    </v-select>
                </div>
                <label v-if="cruiseShipId" for="cruiseId" class="col-lg-4 col-form-label required">{{
                    $t('cruiseSelect')
                    }}</label>
                <div class="col-lg-8">
                  <v-select v-if="cruiseShipId"
                            id="cruiseId"
                            name="cruiseId"
                            v-model="cruiseId"
                            :options="cruiseData" label="name">
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import AccessService from "../api/SelectService";

export default {
  name: "WidgetStart",
  props: {
    cruiseType: {
      type: String,
      default: "sea"
    }
  },
  data: function () {
    return {
      activeTabStartWidget: 1,
      cruiseCompanyId: null,
      cruiseShipId: null,
      cruiseId: null,
      widgetPortId: null,

      widgetCruiseShipName: "",
      widgetCruiseDate: '',
      widgetCruiseDuration: null,

      cruiseCompany: [],
      cruiseShip: [],
      cruiseData: [],
      ports: [],
    }
  },
  methods: {
    handlePortChanged() {
      this.$emit('port:updated', {
        widgetPortId: this.widgetPortId,
      });
    },
    handleCruiseChanged() {
      if (this.cruiseId !== null) {
        this.widgetCruiseShipName = this.cruiseId.ship.ship;
        this.widgetCruiseDate = this.cruiseId.start_date;
        this.widgetCruiseDuration = this.cruiseId.duration;
        this.$emit('cruise:updated', {
          widgetCruiseShipName: this.widgetCruiseShipName,
          widgetCruiseDate: this.widgetCruiseDate,
          widgetCruiseDuration: this.widgetCruiseDuration
        });
      } else {
        this.$emit('cruise:updated', {
          widgetCruiseShipName: "",
          widgetCruiseDate: "",
          widgetCruiseDuration: ""
        });
      }
    }
  },
  watch: {
    async cruiseType() {
      this.ports = await AccessService.getPorts(this.cruiseType);
      this.cruiseCompany = await AccessService.getCompanies(this.cruiseType);
    },
    activeTabStartWidget: function () {
      this.$emit('active-tab:changed', {
        activeTab: this.activeTabStartWidget,
      })
      if (this.activeTabStartWidget === 1) {
        this.handlePortChanged();
      } else {
        this.handleCruiseChanged();
      }
    },
    cruiseCompanyId: async function () {
      if (this.cruiseCompanyId) {
        this.cruiseShip = await AccessService.getShip(this.cruiseCompanyId);
      }
      this.cruiseShipId = null;
      this.cruiseId = null;
    },
    cruiseShipId: async function () {
      this.cruiseId = null;
      this.cruiseData = await AccessService.getCruise(this.cruiseShipId);
      if (this.cruiseData !== null) {
        for (const key of Object.keys(this.cruiseData)) {
          let date = new Date(this.cruiseData[key].start_date).toLocaleDateString();
          this.cruiseData[key]['name'] = this.cruiseData[key].ship.ship + ' - ' + date + ' - ' +
              this.cruiseData[key].duration + ' ' + this.$i18n.t('days') + ' - ' + this.cruiseData[key].destination.destination;
        }
        this.$emit('cruiseShipData', {
          widgetCruiseShipName: this.cruiseData[0].ship.ship,
        });
      }
    },
    cruiseId: function () {
      this.handleCruiseChanged()
    },
    widgetPortId: function () {
      this.handlePortChanged();
    },
  },
  async mounted() {
    this.ports = await AccessService.getPorts(this.cruiseType);
    this.cruiseCompany = await AccessService.getCompanies(this.cruiseType);
  },


}
</script>
